import React, { useEffect } from "react";
import "./home.css";
import { useNavigate } from "react-router-dom";

function Home() {
  const navigate = useNavigate();
  
  useEffect(() => {
    if (!localStorage.getItem('auth')) {
      navigate("/signin");
    }
  }, []);

  return (
    <div className="homepage">
      <h1>Hello Homepage</h1>
      <div
        className="button"
        onClick={() => {
          localStorage.clear();
          navigate("/signin");
        }}
      >
        Logout
      </div>
    </div>
  );
}

export default Home;
